interface FleetPermission {
  feature?: { code?: string | null } | null;
  action?: { code?: string | null } | null;
}

/** Nyckelikonen i flottan kräver ikryssad action. En roll med bara Visa räcker inte. */
export function fleetUserCanConnectKey(
  isGlobalAdmin: boolean,
  permissions: FleetPermission[] | null | undefined
): boolean {
  if (isGlobalAdmin) return true;
  return (permissions ?? []).some((permission) => {
    return permission.feature?.code === 'FLEET' && permission.action?.code === 'CONNECT_KEY';
  });
}
